import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetAuthorArticlesActionType {
  Reset = 'authorArticles/resetAuthorArticles',
}

export type TResetAuthorArticles = ITypedReduxAction<EResetAuthorArticlesActionType.Reset>;
